import { default as React } from 'react';

import { createLazyComponent, LazyModule } from 'owa-bundling';

import styles from './commandBarContainerAsync.scss';
import classNames from 'classnames';

const commandBarModule = new LazyModule(
    () => import(/* webpackChunkName: "CommandBarContainer" */ './commandBarContainer')
);

const CommandBar = createLazyComponent(commandBarModule, m => m.default);
export default () => (
    <div className={classNames(styles.placeholder, styles.pplHubCommandBar)}>
        <CommandBar />
    </div>
);
